import React from "react";
import GlobalStyles from "./styles/GlobalStyles";
import styled from "styled-components";
import Header from "./components/Header";
import Home from "./pages/Home";

const HeaderContainer = styled.div`
  z-index: 9999;
  position: fixed;
  top: 0;
  width: 100%;
`;

function App() {
  return (
    <>
      <GlobalStyles />
      <HeaderContainer>
        <Header />
      </HeaderContainer>
      <Home />
    </>
  );
}

export default App;
